import { render, staticRenderFns } from "./UnavailabilityPeriods.vue?vue&type=template&id=748b2f8a&scoped=true&"
import script from "./UnavailabilityPeriods.vue?vue&type=script&lang=js&"
export * from "./UnavailabilityPeriods.vue?vue&type=script&lang=js&"
import style0 from "./UnavailabilityPeriods.vue?vue&type=style&index=0&id=748b2f8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748b2f8a",
  null
  
)

export default component.exports